import type { EditorCommand } from '@atlaskit/editor-common/types';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';

export const clearRemixThinkingDecoration =
	(): EditorCommand =>
	({ tr }) => {
		tr.setMeta(remixThinkingPluginKey, {
			presentation: { kind: 'clear-decoration' },
			lifecycle: { kind: 'legacy-clear' },
		} satisfies RemixThinkingPluginMeta);

		return tr;
	};
